export default function SendModalComponent({
    onClose,
}: {
    onClose?: () => void
}) {
    return (
        <div
            role="presentation"
            className="MuiDialog-root styles_loggedFormModal__QkhVv styles_dialog__sLwuc"
            style={{ position: "fixed", zIndex: 1300, inset: 0 }}
        >
            <div
                className="MuiBackdrop-root"
                aria-hidden="true"
                onClick={onClose}
                style={{
                    opacity: 1,
                    transition: "opacity cubic-bezier(0.4, 0, 0.2, 1)",
                }}
            />

            <div
                className="MuiDialog-container MuiDialog-scrollPaper"
                role="none presentation"
                tabIndex={-1}
                style={{
                    opacity: 1,
                    transition: "opacity cubic-bezier(0.4, 0, 0.2, 1)",
                }}
            >
                <div className="MuiPaper-root MuiDialog-paper MuiDialog-paperScrollPaper MuiDialog-paperWidthSm MuiDialog-paperFullWidth MuiPaper-elevation24 MuiPaper-rounded">

                    <div className="styles_headerDialog__eP0xR">
                        <div className="MuiDialogTitle-root styles_title__iDbGS">
                            <h2 className="MuiTypography-root MuiTypography-h6">
                                Ý kiến về sản phẩm
                            </h2>
                        </div>
                    </div>

                    <div className="MuiDialogContent-root styles_content__XFqhI">
                        <form>
                            <div className="styles_formTextarea__ng5zd MuiBox-root css-0">
                                <textarea
                                    rows={3}
                                    className="styles_input__htKbU"
                                    maxLength={200}
                                    placeholder="* Vui lòng nhập nội dung câu hỏi bằng tiếng Việt có dấu, tối thiểu 3 ký tự (Bắt buộc)"
                                    name="question"
                                    style={{ height: 85 }}
                                />

                                <div className="styles_textareaCount__pYuWE">
                                    0/ 200
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="MuiDialogActions-root styles_actions__TKot9 MuiDialogActions-spacing">
                        <button
                            className="styles_base__Pdm9S styles_contained__4kDf4 styles_colorSecondary__js_Iq styles_small__QTUmD"
                            onClick={onClose}
                        >
                            Hủy
                        </button>

                        <button
                            className="styles_base__Pdm9S styles_contained__4kDf4 styles_colorPrimary__NGf0C styles_small__QTUmD"
                            onClick={onClose}
                        >
                            Gửi
                        </button>
                    </div>

                </div>
            </div>
        </div>
    )
}
